export const SkipLinks = () => {
  return (
    <div className="sr-only focus-within:not-sr-only focus-within:fixed focus-within:top-0 focus-within:left-0 focus-within:z-[9999] focus-within:p-4 focus-within:bg-background">
      <a
        href="#main-content"
        className="inline-block px-4 py-2 bg-primary text-primary-foreground rounded-md font-medium focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
      >
        Pular para conteúdo principal
      </a>
      <a
        href="#main-navigation"
        className="inline-block ml-2 px-4 py-2 bg-primary text-primary-foreground rounded-md font-medium focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
      >
        Pular para navegação
      </a>
    </div>
  );
};
